import React, { VFC } from 'react';

import { Button, Text } from 'mintel-react-ui';
import { openFeedbackPanel } from 'mintel-taskbar';

import ArticleBlock from '/components/ArticleBlock';
import { ArticleBlockProps, BlockContentJson, ColumnsJson } from '/types';
import useTranslate, { Trans } from '/utils/translations';

import styles from './BlockAnalystFeedback.scss';

const BlockAnalystFeedback: VFC = () => {
  const t = useTranslate();

  const columns: ColumnsJson = {
    layout: 'equal',
    hidden: false,
    type: 'list',
    list: [],
  };

  const blockContent: BlockContentJson = {
    columns: columns,
  };

  const blockProps: ArticleBlockProps = {
    blockId: '1-block-analyst-feedback',
    blockBackgroundType: 'bg-black',
    blockContent: blockContent,
    blockBackgroundOpacity: '0.0',
    blockType: 'block-analyst-feedback',
    blockLinked: false,
  };

  return (
    <ArticleBlock
      {...blockProps}
      columns={[
        <div key="text" className={styles['text']}>
          <Text.Heading3 darkBg>{t('Did you find this useful?')}</Text.Heading3>
          <Text.Body darkBg>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  'Your feedback helps us publish the insight you need.',
                ),
              }}
            />
          </Text.Body>
        </div>,
        <div key="button" className={styles['button-container']}>
          <Button.MutedButton fullWidth handleClick={openFeedbackPanel}>
            <Trans>Rate this piece</Trans>
          </Button.MutedButton>
        </div>,
      ]}
    />
  );
};

export default BlockAnalystFeedback;
